import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/loading")({
  component: LoadingPage,
});

function LoadingPage() {
  useEffect(() => {
    window.close();
  }, []);

  return null;
}
